export const HOSPITALITY_CATEGORY = "Hospitality";
export const SOFTWARE_IT_CATEGORY = "Software / IT";
export const CONSTRUCTION_CATEGORY = "Construction";
export const RETAIL_SALES_CATEGORY = "Retail & Sales";
export const CLEANING_MAINTENANCE_CATEGORY = "Cleaning & Maintenance";
export const SECURITY_CATEGORY = "Security";
export const OFFICE_STAFF_CATEGORY = "Office Staff";
export const DRIVER_CATEGORY = "Driver";


export const HOSPITALITY_POSITIONS = [
  "Front Office / Reception",
  "Guest Relations",
  "Concierge",
  "Bell Boy / Porter",
  "Reservation Staff",
  "Host / Hostess",
  "Food Runner",
  "Restaurant Supervisor",
  "Captain / Head Waiter",
  "Chef (All Levels)",
  "Sous Chef",
  "Commis Chef",
  "Service Crew",
  "Room Attendant",
  "Public Area Cleaner",
  "Laundry Staff",
  "Housekeeping Supervisor",
  "Banquet Staff",
  "Event Setup Crew",
  "Catering Staff",
  "Event Coordinator",
  "Bartender",
  "Bar Assistant",
  "Beverage Server",
  "Juice / Mocktail Maker",
  "Resort Staff",
  "Pool Attendant",
  "Spa Receptionist",
  "Recreation Staff",
  "Cashier",
  "Cashier (Cafe)",
  "Counter Staff",
  "Waiter",
  "Waitress",
  "Barista",
  "Cafe Server",
  "Juice Maker",
  "Drive-Thru Operator",
  "Kitchen Crew",
  "Customer Service Assistant",
  "Kitchen Helper",
  "Pastry & Bakery Staff",
  "Line Cook",
  "Fry Cook",
  "Grill Cook",
  "Sandwich Maker",
  "Food Preparation Staff",
  "Cleaner",
  "Janitor",
  "Dishwasher",
  "Utility Staff",
  "Delivery Driver",
  "Delivery Rider",
  "Packing Staff",
  "Inventory Assistant",
  "Storekeeper",
  "Shift Supervisor",
  "Team Leader",
  "Floor Supervisor",
  "Hotel Manager",
  "Assistant Hotel Manager",
  "Duty Manager",
  "Resort Manager",
  "Front Office Manager",
  "Reception Supervisor",
  "Guest Relations Manager",
  "Concierge Manager",
  "F&B Manager",
  "Assistant Restaurant Manager",
  "Restaurant Manager",
  "Banquet Manager",
  "Catering Manager",
  "Executive Chef",
  "Kitchen Manager",
  "Pastry Chef",
  "Housekeeping Manager",
  "Laundry Manager",
  "Event Manager",
  "Banquet Supervisor",
  "Conference Manager",
  "Wedding Planner",
  "Operations Manager (Hospitality)",
  "Service Manager",
  "Outlet Manager",
  "HSE Manager (Hotel/Restaurant)",
  "Hygiene Manager",
  "Quality Assurance Manager",
  "Procurement Manager (Hotel/F&B)",
  "Store Manager (Hospitality)",
  "Inventory Controller",
  "Transport Coordinator",
  "Chauffeur Supervisor",
  "Guest Transport Manager",
  "Store Manager",
  "Area Manager"
];

export const HOSPITALITY_EXPERIENCE_TYPES = [
  "Fast Food Chain",
  "Casual Dining",
  "Cafe / Coffee Shop",
  "Cloud Kitchen"
];

export const SOFTWARE_IT_POSITIONS = [
  "Software Engineer",
  "Software Developer",
  "Full Stack Developer",
  "Frontend Developer",
  "Backend Developer",
  "Web Developer",
  "Mobile App Developer (iOS / Android)",
  "Game Developer",
  "Embedded Systems Developer",
  "UI Designer",
  "UX Designer",
  "UI/UX Developer",
  "Web Designer",
  "Graphic Designer",
  "Data Analyst",
  "Data Scientist",
  "Data Engineer",
  "Machine Learning Engineer",
  "AI Engineer",
  "Business Intelligence (BI) Developer",
  "Cybersecurity Specialist",
  "Information Security Analyst",
  "Network Engineer",
  "Network Administrator",
  "Security Engineer",
  "DevOps Engineer",
  "Cloud Engineer",
  "Cloud Architect",
  "Site Reliability Engineer (SRE)",
  "System Administrator",
  "QA Engineer",
  "Software Tester",
  "Automation Test Engineer",
  "Manual Tester",
  "Database Administrator (DBA)",
  "Database Developer",
  "SQL Developer",
  "IT Support Specialist",
  "Help Desk Technician",
  "Technical Support Engineer",
  "IT Technician",
  "IT Project Manager",
  "Product Manager",
  "Product Owner",
  "Scrum Master",
  "Technical Lead",
  "Engineering Manager",
  "Blockchain Developer",
  "AR/VR Developer",
  "IoT Engineer",
  "ERP Consultant (SAP, Oracle, etc.)",
  "CRM Developer (Salesforce, etc.)",
  "Junior Software Developer",
  "Intern (Software / IT)",
  "Trainee Engineer"
];

export const SOFTWARE_IT_PROGRAMMING_LANGUAGES = [
  "Java",
  "Python",
  "JavaScript",
  "C++",
  "C#",
  "PHP",
  "Go"
];

export const SOFTWARE_IT_FRAMEWORKS = [
  "React",
  "Angular",
  "Node.js",
  ".NET",
  "Django",
  "Spring Boot",
  "Flutter",
  "React Native"
];

export const SOFTWARE_IT_DATABASE_SKILLS = [
  "MySQL",
  "PostgreSQL",
  "MongoDB",
  "Oracle"
];

export const SOFTWARE_IT_OTHER_SKILLS = [
  "DevOps",
  "AI/ML",
  "Cybersecurity",
  "UI/UX",
  "Cloud Computing",
  "Testing / QA",
  "Networking",
  "Other"
];

export const SOFTWARE_IT_CERTIFICATIONS = [
  "AWS",
  "Azure",
  "Google Cloud",
  "PMP",
  "Scrum Master",
  "Cisco",
  "CompTIA"
];

export const CONSTRUCTION_POSITIONS = [
  "Construction Manager",
  "Project Manager",
  "Site Engineer",
  "Civil Engineer",
  "Mechanical Engineer",
  "Electrical Engineer",
  "Site Supervisor",
  "Foreman",
  "Quantity Surveyor",
  "Estimation Engineer",
  "Architect",
  "Draftsman / AutoCAD Draftsman",
  "Mason (Block / Plaster)",
  "Carpenter (Shuttering / Finishing)",
  "Steel Fixer",
  "Electrician",
  "Plumber",
  "Welder",
  "Painter",
  "Tile Mason",
  "Gypsum / Ceiling Technician",
  "HVAC Technician",
  "AC Technician",
  "JCB Operator",
  "Excavator Operator",
  "Bulldozer Operator",
  "Backhoe Operator",
  "Wheel Loader Operator",
  "Crane Operator",
  "Roller Operator",
  "Grader Operator",
  "General Labor / Helper",
  "Construction Helper",
  "Scaffolder",
  "Rigger",
  "Safety Officer (HSE)",
  "Timekeeper",
  "Storekeeper (Construction Site)",
  "Document Controller"
];

export const RETAIL_SALES_POSITIONS = [
  "Sales Manager",
  "Assistant Sales Manager",
  "Sales Supervisor",
  "Sales Executive",
  "Sales Representative",
  "Sales Associate",
  "Retail Store Manager",
  "Assistant Store Manager",
  "Shop Supervisor",
  "Shop Salesman",
  "Saleslady",
  "Showroom Sales Executive",
  "Cashier",
  "Billing Executive",
  "Customer Service Representative",
  "Merchandiser",
  "Visual Merchandiser",
  "Promoter (In-store / Mall Promoter)",
  "Brand Ambassador",
  "Business Development Executive",
  "Key Account Manager",
  "Tele Sales Executive",
  "Call Center Sales Agent",
  "E-commerce Executive",
  "Online Sales Coordinator"
];

export const CLEANING_MAINTENANCE_POSITIONS = [
  "Cleaning Supervisor",
  "Housekeeping Supervisor",
  "Cleaner / General Cleaner",
  "Office Cleaner",
  "Housekeeper",
  "Room Attendant (Hotel)",
  "Public Area Cleaner",
  "Janitor",
  "Custodian",
  "Carpet Cleaner",
  "Window Cleaner",
  "Laundry Attendant",
  "Pressing / Ironing Staff",
  "Waste Management Worker",
  "Garbage Collector",
  "Pest Control Technician",
  "Cleaning Helper"
];

export const DOMESTIC_HELPER_POSITIONS = [
  "Domestic Helper",
  "Maid",
  "Housemaid",
  "Houseboy",
  "Housekeeper",
  "Household Administrator",
  "House Manager",
  "Domestic Assistant",
  "Nanny",
  "Baby Sitter",
  "Caregiver",
  "Elder Care",
  "Pet Sitter",
  "Home Caregiver",
  "Personal Assistant",
  "Home Cook",
  "Cook",
  "Cook (Company / House)",
  "Personal Chef",
  "Home Driver",
  "Personal Driver",
  "Lady Driver",
  "Driver",
  "Private Drivers",
  "Motorbike Driver",
  "Chauffeur",
  "Tailor",
  "Teacher",
  "Trainer",
  "Tutor",
  "Beautician",
  "Gardener",
  "Butler",
  "Laundry Worker",
  "Cleaner",
  "Maintenance Worker",
  "Home Nurse",
  "Kitchen Staff",
  "Dining Room Attendant",
  "Event Coordinator",
  "Farmar",
  "Maid + Driver (Couple)",
  "Housemaid + Driver (Couple)",
  "Housekeeper + Driver (Couple)",
  "Cleaner + Driver (Couple)",
  "Laundry Worker + Driver (Couple)",
  "Maid + Gardener (Couple)",
  "Maid + Watchman (Couple)",
  "Maid + Security Guard (Couple)",
  "Maid + Maintenance Helper (Couple)",
  "Housekeeper + Gardener (Couple)",
  "Cleaner + Gardener (Couple)",
  "Nanny + Driver (Couple)",
  "Babysitter + Driver (Couple)",
  "Child Caregiver + Driver (Couple)",
  "Nanny + Gardener (Couple)",
  "Babysitter + Watchman (Couple)",
  "Caregiver + Driver (Couple)",
  "Home Nurse + Driver (Couple)",
  "Private Nurse + Driver (Couple)",
  "Elderly Caregiver + Driver (Couple)",
  "Caregiver + Watchman (Couple)",
  "Cook + Driver (Couple)",
  "Home Cook + Driver (Couple)",
  "Private Cook + Driver (Couple)",
  "Chef + Driver (Couple)",
  "Cook + Gardener (Couple)",
  "Maid + Cook (Couple)",
  "Maid + Babysitter (Couple)",
  "Maid + Caregiver (Couple)",
  "Cook + Caregiver (Couple)",
  "Cook + Babysitter (Couple)",
  "Maid + Housekeeper (Couple)",
  "Villa Caretaker Couple",
  "Estate Management Couple",
  "House Manager + Housekeeper (Couple)",
  "Butler + Housekeeper (Couple)",
  "Property Caretaker Couple",
  "Driver + Gardener (Couple)",
  "Driver + Watchman (Couple)",
  "Driver + Maintenance (Couple)",
  "Gardener + Watchman (Couple)",
  "Security Guard Couple",
  "Pet Caretaker + Driver (Couple)",
  "Home Beautician + Driver (Couple)"
];

export const HEALTHCARE_POSITIONS = [
  "Home Nurse",
  "House Nurse",
  "Home Care Nurse",
  "Hospital Nurse",
  "Physiotherapy",
  "Midwife (Midwifery)",
  "Any Nurse",
  "Nurse",
  "Clinic / Shop Nurse",
  "School Nurse",
  "Company / Industrial Nurse",
  "Elderly Care Nurse",
  "Special Care Nurse",
  "Emergency / Ambulance Nurse",
  "Lab / Assistant Nurse",
  "Hotel / Resort Nurse",
  "General Physician",
  "Specialist Doctor",
  "Consultant Doctor",
  "Resident Doctor",
  "Surgeon",
  "Internal Medicine Specialist",
  "Pediatrician",
  "Gynecologist",
  "Orthopedic Doctor",
  "Orthopedic Surgeon",
  "Cardiologist",
  "Neurologist",
  "Dermatologist",
  "Gastroenterologist",
  "Pulmonologist",
  "ENT Specialist",
  "Ophthalmologist (Eye Doctor)",
  "General Surgeon",
  "Neurosurgeon",
  "Cardiothoracic Surgeon",
  "Plastic Surgeon",
  "Urologist",
  "Anesthesiologist",
  "Radiologist",
  "Pathologist",
  "Psychiatrist",
  "Emergency Doctor",
  "Emergency Medicine Doctor",
  "ICU Doctor",
  "ICU Specialist",
  "Family Medicine Doctor",
  "Dental Doctor",
  "General Dentist",
  "Orthodontist",
  "Oral Surgeon",
  "Prosthodontist",
  "Medical Officer",
  "Registered Nurse"
];

export const PROFESSIONAL_INFO_CATEGORIES = [
  "Domestic Helper",
  DRIVER_CATEGORY,
  "Hospital",
  HOSPITALITY_CATEGORY,
  SOFTWARE_IT_CATEGORY,
  CONSTRUCTION_CATEGORY,
  RETAIL_SALES_CATEGORY,
  CLEANING_MAINTENANCE_CATEGORY,
  SECURITY_CATEGORY,
  OFFICE_STAFF_CATEGORY,
  "Company Worker"
];

export const JOB_SEEKER_CATEGORY_OPTIONS = [
  "Domestic Helper",
  DRIVER_CATEGORY,
  "Healthcare",
  HOSPITALITY_CATEGORY,
  SOFTWARE_IT_CATEGORY,
  CONSTRUCTION_CATEGORY,
  RETAIL_SALES_CATEGORY,
  CLEANING_MAINTENANCE_CATEGORY,
  SECURITY_CATEGORY,
  OFFICE_STAFF_CATEGORY,
  "Company Worker"
];

export const EMPLOYER_CATEGORY_OPTIONS = [
  "Domestic Helper",
  DRIVER_CATEGORY,
  "Healthcare",
  HOSPITALITY_CATEGORY,
  SOFTWARE_IT_CATEGORY,
  CONSTRUCTION_CATEGORY,
  RETAIL_SALES_CATEGORY,
  CLEANING_MAINTENANCE_CATEGORY,
  SECURITY_CATEGORY,
  OFFICE_STAFF_CATEGORY,
  "Company Worker"
];

export const SECURITY_POSITIONS = [
  "Security Guard",
  "Security Officer",
  "Senior Security Officer",
  "Security Supervisor",
  "Security Team Leader",
  "CCTV Operator",
  "CCTV Supervisor",
  "Control Room Operator",
  "Security Manager",
  "Security Coordinator",
  "Security Driver",
  "Security Receptionist",
  "Access Control Officer",
  "Gate Pass Officer",
  "Patrol Guard",
  "Watchman",
  "Loss Prevention Officer",
  "Fire Watcher",
  "Fire & Safety Officer",
  "HSE Officer"
];

export const OFFICE_STAFF_POSITIONS = [
  "Office Assistant",
  "Receptionist",
  "Secretary",
  "Data Entry Operator",
  "Document Controller",
  "HR Assistant",
  "Accountant",
  "Admin Officer",
  "Customer Service Representative"
];

export const DRIVER_POSITIONS = [
  "Light Driver",
  "Heavy Driver",
  "Truck Driver",
  "Small Truck Driver",
  "Heavy Truck Driver",
  "Heavy Truck Driver (CE)",
  "Trailer Driver",
  "Heavy Trailer Driver",
  "Truck with Trailer Driver",
  "Dachser Truck Driver",
  "Mercedes-Benz Actros Driver",
  "CE License Driver (EU)",
  "Long Distance Truck Driver (EU)",
  "Fuel Tanker Driver",
  "Ready-Mix Driver",
  "Bus Driver",
  "Taxi Driver",
  "Home Driver",
  "Company Driver",
  "Personal Driver",
  "Lady Driver",
  "Private Driver",
  "Private Drivers",
  "Delivery Driver",
  "Delivery Drivers",
  "Truck Drivers",
  "Motorbike Driver",
  "Bike Driver",
  "Chauffeur",
  "Delivery Rider",
  "Delivery Van Driver",
  "Security Driver",
  "Ambulance Driver",
  "School Bus Driver",
  "Limousine Driver",
  "Valet Driver",
  "Hotel Driver Required",
  "Valet Driver Needed",
  "Forklift Driver",
  "Driver (Company / House)",
  "Driver"
];

export const COMPANY_WORKER_DUAL_CATEGORY_POSITIONS = [
  "Driver",
  "Driver (Company / House)",
  "Light Driver",
  "Cook",
  "Cook (Company / House)"
];

export const filterCompanyWorkerPositions = ({
  positions,
  domesticPositions,
  dualCategoryPositions = COMPANY_WORKER_DUAL_CATEGORY_POSITIONS,
  healthcarePositions = HEALTHCARE_POSITIONS
}) => {
  const domesticSet = new Set(domesticPositions);
  const healthcareSet = new Set(healthcarePositions);
  const hospitalitySet = new Set(HOSPITALITY_POSITIONS);
  const softwareItSet = new Set(SOFTWARE_IT_POSITIONS);
  const constructionSet = new Set(CONSTRUCTION_POSITIONS);
  const retailSalesSet = new Set(RETAIL_SALES_POSITIONS);
  const cleaningMaintenanceSet = new Set(CLEANING_MAINTENANCE_POSITIONS);
  const securitySet = new Set(SECURITY_POSITIONS);
  const officeStaffSet = new Set(OFFICE_STAFF_POSITIONS);
  const driverSet = new Set(DRIVER_POSITIONS);
  const dualSet = new Set(dualCategoryPositions);

  return positions.filter(
    (position) =>
      (!domesticSet.has(position) &&
        !healthcareSet.has(position) &&
        !hospitalitySet.has(position) &&
        !softwareItSet.has(position) &&
        !constructionSet.has(position) &&
        !retailSalesSet.has(position) &&
        !cleaningMaintenanceSet.has(position) &&
        !securitySet.has(position) &&
        !officeStaffSet.has(position) &&
        !driverSet.has(position)) ||
      dualSet.has(position)
  );
};

export const isSecurityPosition = (position) =>
  SECURITY_POSITIONS.includes(position);

export const isOfficeStaffPosition = (position) =>
  OFFICE_STAFF_POSITIONS.includes(position);

export const isHospitalityPosition = (position) =>
  HOSPITALITY_POSITIONS.includes(position);

export const isSoftwareItPosition = (position) =>
  SOFTWARE_IT_POSITIONS.includes(position);

export const isConstructionPosition = (position) =>
  CONSTRUCTION_POSITIONS.includes(position);

export const isRetailSalesPosition = (position) =>
  RETAIL_SALES_POSITIONS.includes(position);

export const isCleaningMaintenancePosition = (position) =>
  CLEANING_MAINTENANCE_POSITIONS.includes(position);

export const isDriverPosition = (position) =>
  DRIVER_POSITIONS.includes(position);

export const toCategoryDisplayLabel = (category) =>
  category === "Hospital" ? "Healthcare" : category;

export const fromCategoryDisplayLabel = (category) =>
  category === "Healthcare" ? "Hospital" : category;

// Nationality / Country options for contact forms
export const COUNTRY_NATIONALITIES = [
  "Afghan", "Albanian", "Algerian", "American", "Angolan", "Argentine", "Armenian",
  "Australian", "Austrian", "Azerbaijani", "Bahraini", "Bangladeshi", "Belarusian",
  "Belgian", "Belizean", "Beninese", "Bhutanese", "Bolivian", "Bosnian", "Brazilian",
  "British", "Bruneian", "Bulgarian", "Burkinabe", "Burmese", "Burundian", "Cambodian",
  "Cameroonian", "Canadian", "Cape Verdean", "Central African", "Chadian", "Chilean",
  "Chinese", "Colombian", "Comorian", "Congolese", "Costa Rican", "Croatian", "Cuban",
  "Cypriot", "Czech", "Danish", "Djiboutian", "Dominican", "Dutch", "Ecuadorean",
  "Egyptian", "Emirati", "Eritrean", "Estonian", "Ethiopian", "Fijian", "Filipino",
  "Finnish", "French", "Gabonese", "Gambian", "Georgian", "German", "Ghanaian",
  "Greek", "Guatemalan", "Guinean", "Guyanese", "Haitian", "Honduran", "Hungarian",
  "Icelandic", "Indian", "Indonesian", "Iranian", "Iraqi", "Irish", "Israeli",
  "Italian", "Ivorian", "Jamaican", "Japanese", "Jordanian", "Kazakh", "Kenyan",
  "Kuwaiti", "Kyrgyz", "Laotian", "Latvian", "Lebanese", "Liberian", "Libyan",
  "Lithuanian", "Luxembourgish", "Malagasy", "Malawian", "Malaysian", "Maldivian",
  "Malian", "Maltese", "Mauritanian", "Mauritian", "Mexican", "Moldovan", "Mongolian",
  "Montenegrin", "Moroccan", "Mozambican", "Namibian", "Nepalese", "New Zealander",
  "Nicaraguan", "Nigerian", "Nigerien", "North Korean", "North Macedonian", "Norwegian",
  "Omani", "Pakistani", "Palestinian", "Panamanian", "Papua New Guinean", "Paraguayan",
  "Peruvian", "Polish", "Portuguese", "Qatari", "Romanian", "Russian", "Rwandan",
  "Saudi", "Senegalese", "Serbian", "Sierra Leonean", "Singaporean", "Slovak",
  "Slovenian", "Somali", "South African", "South Korean", "South Sudanese", "Spanish",
  "Sri Lankan", "Sudanese", "Swedish", "Swiss", "Syrian", "Taiwanese", "Tajik",
  "Tanzanian", "Thai", "Togolese", "Trinidadian", "Tunisian", "Turkish", "Turkmen",
  "Ugandan", "Ukrainian", "Uruguayan", "Uzbek", "Venezuelan", "Vietnamese", "Yemeni",
  "Zambian", "Zimbabwean",
];
